import React from 'react';
import styled from 'styled-components';
import { ArrowRight, Check, CircleDot } from 'lucide-react';
import { Journey, SmallButton } from '../../abf/onboarding/review/contractReviewStyles';
import type { FacilityJourney } from './facilityJourney';

const Strip = styled(Journey)<{ $count: number }>`
  --review-muted: #a8b6ca;
  grid-template-columns: repeat(${p => p.$count}, 1fr);
  margin: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  color: #e5edf7;
  @media (max-width: 1000px) { grid-template-columns: repeat(2, 1fr); li:nth-child(odd) { border-left: 0; } li:nth-child(n + 3) { border-top: 1px solid #29374b; } }
  @media (max-width: 700px) { grid-template-columns: 1fr; li { border-left: 0; } }
`;

const NextStep = styled.div`
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  padding: 14px 18px; background: #142438; color: #e5edf7;
  border: 1px solid #43617f; border-top: 0; border-radius: 0 0 10px 10px;
  strong, span { display: block; }
  strong { font-size: 14px; }
  span { color: #b6c7da; font-size: 13px; margin-top: 3px; }
  button { flex-shrink: 0; border-color: #67c6f4; }
  @media (max-width: 700px) { flex-direction: column; align-items: stretch; }
`;

interface Props {
  journey: FacilityJourney;
  onNext?: () => void;
}

/** Where the facility stands and the one thing to do next, in the ABF facility standard. */
const FacilityJourneyBar: React.FC<Props> = ({ journey, onNext }) => (
  <section aria-label="Facility progress and next step" style={{ marginBottom: '1rem' }}>
    <Strip $count={journey.stops.length}>
      {journey.stops.map((stop, index) => (
        <li key={stop.title} data-current={index === journey.current} aria-current={index === journey.current ? 'step' : undefined}>
          <span className={`step-icon ${stop.done ? 'done' : ''}`}>{stop.done ? <Check size={15} /> : <CircleDot size={15} />}</span>
          <div><strong>{index + 1}. {stop.title}</strong><small>{stop.detail}</small></div>
        </li>
      ))}
    </Strip>
    <NextStep role="status">
      <div><strong>{journey.next.headline}</strong>{journey.next.reason && <span>{journey.next.reason}</span>}</div>
      {journey.next.action && onNext && (
        <SmallButton type="button" onClick={onNext}>{journey.next.action} <ArrowRight size={14} /></SmallButton>
      )}
    </NextStep>
  </section>
);

export default FacilityJourneyBar;
